import React from "react";
import AuthView from "./AuthView";
import AuthViewNew from "./AuthViewNew";

export const AuthContainer = () => {
  //return <AuthView />;
  return <AuthViewNew />;
};

export default AuthContainer;
